module.exports = __webpack_public_path__ + "static/media/PDF_39.c825cdf0.pdf";